import { render, staticRenderFns } from "./dibudaohang.vue?vue&type=template&id=68821efc&scoped=true&"
import script from "./dibudaohang.vue?vue&type=script&lang=js&"
export * from "./dibudaohang.vue?vue&type=script&lang=js&"
import style0 from "./dibudaohang.vue?vue&type=style&index=0&id=68821efc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68821efc",
  null
  
)

export default component.exports